<template>
  <div>
    <ElConfigProvider :locale="RULang">
      <!-- Полоска прогресса вверху: страницы ждут данных на сервере, и без
           неё переход по разделу выглядит как зависший клик -->
      <NuxtLoadingIndicator color="#008001" :height="3" />
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </ElConfigProvider>
  </div>
</template>

<script setup>
import RULang from "element-plus/dist/locale/ru.min.mjs";

// Тема — классом на <html> прямо в ответе сервера (cookie «theme»), без вспышки
const { isDark } = useTheme();
useHead({ htmlAttrs: { class: computed(() => (isDark.value ? "dark" : "")) } });

</script>

<style>
.el-pagination__sizes .el-select {
  width: 170px !important;
}
</style>